import ApiClient from './ApiClient';

// GET /api/v2/accounts/:id/agent_status_reports — status efetivo ao vivo de cada
// agente e totais de hoje (online / pausa). Alimenta a Visão Geral de Agentes.
class AgentStatusReportsAPI extends ApiClient {
  constructor() {
    super('agent_status_reports', { accountScoped: true, apiVersion: 'v2' });
  }
}

export default new AgentStatusReportsAPI();
